<template>
  <div
    v-if="quickShareItem"
    class="p-2 d-flex flex-column"
  >
    <p>
      Quick sharing <b class="text-break-anywhere ">{{ fileName }}</b>
    </p>
    <custom-alert
      variant="secondary"
      text-class="text-break-anywhere"
    >
      Anyone who has Quick Share URL will have access to view this file <b>({{ quickShareItem.key }})</b>, even if it's set to private.
    </custom-alert>
    <template v-if="!generated">
      <b-form-group
        class="text-secondary"
        label="Duration"
      >
        <b-form-radio-group
          v-model="duration"
          :disabled="generatingQuickShareUrl"
          :options="durationOptions"
          name="upload-is-public"
          class="d-flex flex-column flex-sm-row justify-content-between"
        />
      </b-form-group>
      <b-button
        variant="primary"
        class="mt-2"
        :disabled="generatingQuickShareUrl"
        @click="generate"
      >
        <span
          v-if="generatingQuickShareUrl"
        >
          <b-spinner
            small
          />

          Generating
        </span>
        <span
          v-else
        >

          Generate Quick Share URL
        </span>
      </b-button>
    </template>
    <template v-else>
      <p class="text-success text-sm mb-1">
        Here is your quick share url, please be careful with it.
      </p>
      <b-input-group>
        <template #append>
          <b-button
            v-clipboard:copy="generatedUrl"
            v-clipboard:success="copySuccess"
            variant="bg-gray"
            class="border-left-0"
          >
            <span>
              <GjIcon
                name="Copy"
              />
            </span>
          </b-button>
        </template>
        <b-form-input
          id="generated_url"
          class="mr-0"
          :value="generatedUrl"
          readonly
        />
      </b-input-group>
      <b-button
        variant="outline-primary"
        class="mt-2"
        @click="()=>{generated=false}"
      >
        <GjIcon
          name="Refresh"
          class="icon-left"
        />
        Generate Another Quick Share URL

      </b-button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'QuickShare',
  props: {
    quickShareItem: {
      type: Object,
      default: null,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      duration: 60,
      durationOptions: [
        { text: '1 hour', value: 60 },
        { text: '6 hours', value: 60 * 6 },
        { text: '1 day', value: 60 * 24 },
        { text: '3 days', value: 60 * 24 * 3 },
        { text: '1 week', value: 60 * 24 * 7 },
      ],
      generated: false,
      generatedUrl: null,
    }
  },
  computed: {
    fileName() {
      const tempHelperArr = this.quickShareItem.key.split('/').filter(item => item)
      return tempHelperArr[tempHelperArr.length - 1]
    },
    generatingQuickShareUrl() { return this.$store.state.accountObjects.generatingQuickShareUrl },
    bucketName() { return this.$route.params.id },
  },
  methods: {
    generate() {
      this.$store.dispatch('accountObjects/generateQuickShareUrl', {
        accountId: this.accountId,
        query: {
          key: this.quickShareItem.key,
          bucketName: this.bucketName,
          duration: this.duration,
        },
      }).then(res => {
        this.generatedUrl = res.data.result
        this.generated = true
        this.successToast('Quick share url generated successfully.')
      }).catch(() => {
        this.errorToast('Couldn\'t generate quick share url. Please try again later.')
      })
    },
  },
}
</script>

<style>

</style>
